import { ReactNode, useState } from "react";
import classNames from "classnames";

import "./accordion.scss";

type AccordionProps = {
  header: string | ReactNode;
  expandedContent: string;
  onClick?: (expanded: boolean) => void;
};
export default function Accordion({
  header,
  expandedContent,
  onClick,
}: AccordionProps) {
  const [showExpanded, setShowExpanded] = useState(false);

  return (
    <div className="accordion mt-3" tabIndex={0}>
      <div
        onClick={() => {
          onClick?.(!showExpanded);
          setShowExpanded(!showExpanded);
        }}
        className="accordion-header"
        aria-expanded="false"
      >
        <h3 className="fs-h4">{header}</h3>
        <i
          className={classNames("fbr-icon-plus", {
            "is-active": showExpanded,
          })}
        />
      </div>
      {showExpanded && (
        <div className="accordion-body">
          <div
            className="text-container"
            dangerouslySetInnerHTML={{ __html: expandedContent }}
          />
        </div>
      )}
    </div>
  );
}
